// extracted by mini-css-extract-plugin
export default {"form":"ComercialForms_form__yFxCc"};